module.exports = __webpack_public_path__ + "img/design3.96b6dfa9.png";